<template>
  <Landing />
</template>

<script>
import Landing from '@/components/Landing/Landing.vue'

export default {
  name: 'App',
  components: {
    Landing
  }
}
</script>
